// Brand assets provided by the store owner
export const ASSETS = {
  heroBox: "https://customer-assets-rejwkqb3.emergentagent.net/job_99442ed7-208a-4183-bc96-8c5d4d92346f/artifacts/cift0b5c_ChatGPT%20Image%20Aug%2029%2C%202026%2C%2005_27_23%20PM.png",
  banner: "https://customer-assets-lxgj4vgw.emergentagent.net/job_sinful-indulgence/artifacts/e71ihlm5_AD%20Choc%20Banner.png",
  logo: "/api/files/afterdark/products/440808e9-b001-4e0c-8cda-12da38ad8071.png",
  slogan: "/api/files/afterdark/products/9aff0934-2618-4c71-ac55-bec13e157e41.png",
  moon: "https://customer-assets-lxgj4vgw.emergentagent.net/job_sinful-indulgence/artifacts/jtyxb3la_Logo%20Image%20Transparent.png",
  heroBg: "/api/files/afterdark/products/7a118e15-1692-410a-b6dd-40528a57dd61.jpg",
  heroGold: "https://customer-assets-lxgj4vgw.emergentagent.net/job_sinful-indulgence/artifacts/4gy67vp8_image-1788062739481.jpeg",
  heroBgWide: "/api/files/afterdark/products/65edad36-bffc-4372-92bc-94370511d586.jpg",
  heroSubject: "/api/files/afterdark/products/7b0787f1-cab3-4b9d-a54c-3359ded08473.jpg",
};

export const CATEGORIES = [
  { name: "Plain Chocolate", blurb: "Pure dark chocolate", from: 19.99,
    image: "/api/files/afterdark/products/9b8bc4a7-e1d1-4057-a892-ee58ee15d060.jpg" },
  { name: "Silver", blurb: "Moonlit edible silver", from: 23.99,
    image: "/api/files/afterdark/products/7921beb9-c0c6-450b-9740-4d6d8f173b91.jpg" },
  { name: "Gold", blurb: "Gilded in edible gold", from: 25.99,
    image: "/api/files/afterdark/products/cabec7a1-517d-4cf9-b9ce-8c790aaecc4d.jpg" },
];

export const COLLECTIONS = [
  { name: "Plain Chocolate", tagline: "Three sculpted designs in pure, velvety dark chocolate.",
    image: "/api/files/afterdark/products/9b8bc4a7-e1d1-4057-a892-ee58ee15d060.jpg" },
  { name: "Silver", tagline: "Three designs brushed in shimmering edible silver.",
    image: "/api/files/afterdark/products/7921beb9-c0c6-450b-9740-4d6d8f173b91.jpg" },
  { name: "Gold", tagline: "Three designs gilded in luxurious edible gold.",
    image: "/api/files/afterdark/products/cabec7a1-517d-4cf9-b9ce-8c790aaecc4d.jpg" },
];

// Home bento tiles — matched to the 3 signature boxes by name.
export const HOME_TILES = [
  { key: "Adonis", title: "Adonis", imageIndex: 1,
    image: "/api/files/afterdark/products/9a1c6fc8-6dc8-4f6f-a6c5-6659a710caa9.jpg",
    tagline: "Bold, dominant and unapologetically masculine — sculpted for the one who takes the lead." },
  { key: "Muse", title: "Muse", imageIndex: 2,
    image: "/api/files/afterdark/products/129878b6-6991-4337-9a1e-ae2965bbc65b.jpg",
    tagline: "Bare, magnetic and quietly alluring — a subtle study of the body that draws you inward." },
  { key: "Karma", title: "Karma", imageIndex: 0,
    image: "/api/files/afterdark/products/9b8bc4a7-e1d1-4057-a892-ee58ee15d060.jpg",
    tagline: "Fluid, curious and endlessly versatile — for the explorer who refuses to be defined." },
];
